module.exports = __webpack_public_path__ + "assets/img/new-user-popup.96d15a4c.png";